import { memo } from "react";
import Box from "@mui/material/Box";
import ExerciseRecordingVideoDialog from "./ExerciseRecordingVideoDialog";
import type { MuxMeasurementVideo } from "types";
import ExerciseRecordingVideoPreview from "./ExerciseRecordingVideoPreview";
import useBoolean from "hooks/useBoolean";
import useGetVideoThumbnailUrl from "./useGetVideoThumbnailUrl";

interface ExerciseRecordingVideoItemProps {
  measurementId: string;
  video: MuxMeasurementVideo;
}

function ExerciseRecordingVideoItem(props: ExerciseRecordingVideoItemProps) {
  const { measurementId, video } = props;

  const { value: open, toggle } = useBoolean();
  const { src, status } = useGetVideoThumbnailUrl(video);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mx: 1.5,
        }}
      >
        <ExerciseRecordingVideoPreview status={status} src={src} onClick={toggle} />
      </Box>
      <ExerciseRecordingVideoDialog video={video} measurementId={measurementId} open={open} handleOnClose={toggle} />
    </>
  );
}

export default memo(ExerciseRecordingVideoItem);
